import { ActiveDriver } from '../models';
import {
  translateStatus,
  formatRelativeTime,
  getDriverName,
} from './DriverPopup.utils';

interface DriverPopupContentProps {
  driver: ActiveDriver;
}

export const DriverPopupContent = ({
  driver,
}: DriverPopupContentProps): string => {
  const driverName = getDriverName(driver);
  const translatedStatus = translateStatus(driver.status);
  const lastUpdate = driver.updatedAt || driver.createdAt;
  const relativeTime = formatRelativeTime(lastUpdate);

  const header = `
    <div style="
      border-bottom: 2px solid #f97316;
      padding-bottom: 8px;
      margin-bottom: 12px;
    ">
      <div style="
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 4px;
      ">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4z" fill="#f97316" stroke="#000000" stroke-width="1.5"/>
          <circle cx="6" cy="17" r="1.5" fill="#fff" stroke="#000000" stroke-width="1"/>
          <circle cx="18" cy="17" r="1.5" fill="#fff" stroke="#000000" stroke-width="1"/>
        </svg>
        <strong style="
          font-size: 16px;
          color: #1f2937;
          margin: 0;
        ">${driverName}</strong>
      </div>
    </div>
  `;

  const statusSection = driver.status
    ? `
    <div style="
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 8px;
    ">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" fill="#10b981" stroke="#059669" stroke-width="2"/>
        <circle cx="12" cy="12" r="4" fill="#fff"/>
      </svg>
      <span style="
        font-size: 14px;
        color: #374151;
      ">${translatedStatus}</span>
    </div>
  `
    : '';

  const speedSection =
    driver.speed !== undefined
      ? `
    <div style="
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 8px;
    ">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" fill="#3b82f6"/>
        <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z" fill="#3b82f6"/>
      </svg>
      <span style="
        font-size: 14px;
        color: #374151;
      ">${driver.speed.toFixed(1)} km/h</span>
    </div>
  `
      : '';

  const batterySection =
    driver.batteryLevel !== undefined
      ? `
    <div style="
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 8px;
    ">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="7" width="18" height="10" rx="2" stroke="${driver.batteryLevel < 0.2 ? '#ef4444' : driver.batteryLevel < 0.5 ? '#f59e0b' : '#10b981'}" stroke-width="2" fill="none"/>
        <rect x="4" y="9" width="${14 * driver.batteryLevel}" height="6" rx="1" fill="${driver.batteryLevel < 0.2 ? '#ef4444' : driver.batteryLevel < 0.5 ? '#f59e0b' : '#10b981'}"/>
        <rect x="20" y="10" width="2" height="4" fill="#6b7280"/>
      </svg>
      <span style="
        font-size: 14px;
        color: #374151;
      ">${(driver.batteryLevel * 100).toFixed(0)}%</span>
    </div>
  `
      : '';

  const lastUpdateSection = `
    <div style="
      display: flex;
      align-items: center;
      gap: 8px;
      color: #6b7280;
      font-size: 12px;
      margin-top: 4px;
    ">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
        <path d="M12 6v6l4 2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <span>Última actualización: ${relativeTime}</span>
    </div>
  `;

  return `
    <div style="
      min-width: 200px;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    ">
      ${header}
      ${statusSection}
      ${speedSection}
      ${batterySection}
      ${lastUpdateSection}
    </div>
  `;
};
